import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
const NoteTitle = ({ title, customStyle }) => (_jsx(Box, { sx: {
        minHeight: '45px',
        color: 'secondary.contrastText',
        borderRadius: 2,
        pl: 1.5,
        pr: 1.5,
        background: 'primary.dark',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...customStyle,
    }, children: _jsx(Typography, { component: "div", fontWeight: "fontWeightBold", 
        // style={{color:"#007bad"}}
        sx: {
            // eslint-disable-next-line max-len
            color: (t) => t.portal?.courseDeliveryPage?.notesBoxTextColor || t.palette.contract.main,
        }, children: title || '' }) }));
NoteTitle.defaultProps = {
    customStyle: {},
};
export default NoteTitle;
//# sourceMappingURL=NoteTitle.js.map